import React from 'react';

export default function SheepTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="25.97,11.65 16.01,11.65 14.88,2.0 24.84,2.0" fill="#C3AAC3" />
      <polygon points="16.01,11.65 25.97,11.65 23.24,14.05 13.28,14.05" fill="#986E98" opacity="0.95" />
      <polygon points="16.01,11.65 13.28,14.05 12.15,4.4 14.88,2.0" fill="#986E98" opacity="0.95" />
      <polygon points="24.49,37.36 14.66,37.36 17.2,18.18 27.04,18.18" fill="#C3AAC3" />
      <polygon points="14.66,37.36 24.49,37.36 21.77,32.23 11.93,32.23" fill="#986E98" opacity="0.95" />
      <polygon points="14.66,37.36 11.93,32.23 14.47,13.06 17.2,18.18" fill="#986E98" opacity="0.95" />
      <polygon points="26.06,38.0 13.77,38.0 16.31,18.83 28.61,18.83" fill="#C3AAC3" />
      <polygon points="13.77,38.0 26.06,38.0 22.66,31.59 10.36,31.59" fill="#986E98" opacity="0.95" />
      <polygon points="13.77,38.0 10.36,31.59 12.9,12.42 16.31,18.83" fill="#986E98" opacity="0.95" />
      <polygon points="26.06,38.0 13.77,38.0 16.31,18.83 28.61,18.83" fill="#C3AAC3" />
      <polygon points="13.77,38.0 26.06,38.0 22.66,31.59 10.36,31.59" fill="#986E98" opacity="0.95" />
      <polygon points="13.77,38.0 10.36,31.59 12.9,12.42 16.31,18.83" fill="#986E98" opacity="0.95" />
      <polygon points="29.64,37.29 19.68,37.29 19.68,32.37 29.64,32.37" fill="#C3AAC3" />
      <polygon points="19.68,37.29 29.64,37.29 26.69,35.81 16.73,35.81" fill="#986E98" opacity="0.95" />
      <polygon points="19.68,37.29 16.73,35.81 16.73,30.9 19.68,32.37" fill="#986E98" opacity="0.95" />
      <polygon points="29.64,37.29 19.68,37.29 19.68,32.37 29.64,32.37" fill="#C3AAC3" />
      <polygon points="19.68,37.29 29.64,37.29 26.69,35.81 16.73,35.81" fill="#986E98" opacity="0.95" />
      <polygon points="19.68,37.29 16.73,35.81 16.73,30.9 19.68,32.37" fill="#986E98" opacity="0.95" />
    </svg>
  );
}
